import React from 'react';

export const WelcomeFeedIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path fill="#fff" fillOpacity=".01" d="M0 0h16v16H0z" />
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M2.749 7.635c0-2.279 2.355-4.133 5.251-4.133s5.252 1.854 5.252 4.133S10.896 11.767 8 11.767 2.749 9.914 2.749 7.635m11.13 5.828v-.002s-1.173-1.694-.576-2.337l-.028.015c.92-.962 1.475-2.18 1.475-3.504C14.75 4.528 11.722 2 8 2S1.25 4.528 1.25 7.635 4.278 13.27 8 13.27c1.065 0 2.07-.213 2.968-.582.752.767 1.715 1.18 2.43 1.29l.001-.003q.06.022.123.025a.386.386 0 0 0 .357-.537"
			clipRule="evenodd"
		/>
		<path
			fill="currentColor"
			d="M6.486 7.117a.965.965 0 1 1 .001-1.93.965.965 0 0 1 0 1.93m2.894 0a.964.964 0 1 1 0-1.93.964.964 0 0 1 0 1.93m.26 1.526a.604.604 0 0 1 .899.804 3.5 3.5 0 0 1-4.03.862A3.5 3.5 0 0 1 5.33 9.45a.603.603 0 0 1 .897-.805c.869.967 2.545.967 3.412-.003"
		/>
	</svg>
);
